export const hasMutation = (content, language) => {
  const name = content.name;
  if (name[language]) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/modules/EmployeeList/utils.js